import {
  RegistrationFormData,
  FieldConfig,
  PhoneFieldConfig,
  EmailSendDelay,
  BOOKING_DEFAULTS,
} from "../types";

const convertMinutesToSendDelay = (
  minutes: number | string
): EmailSendDelay => {
  if (typeof minutes === "string") {
    return minutes as EmailSendDelay;
  }

  const minuteMap: Record<number, EmailSendDelay> = {
    0: "immediate",
    60: "1hour",
    360: "6hours",
    1440: "1day",
    2880: "2days",
  };

  return minuteMap[minutes] ?? "immediate";
};

export const getDefaultValues = (
  prefs?: Partial<{ custom_registration?: Partial<RegistrationFormData> }> | any
): RegistrationFormData => {
  const p = (prefs?.custom_registration ?? prefs ?? {}) as any;

  const createFieldConfig = (fieldName: string): FieldConfig => {
    if (p.fields?.[fieldName]) {
      return {
        visible: p.fields[fieldName].visible ?? false,
        required: p.fields[fieldName].required ?? false,
      };
    }
    if (p.requiredFields?.[fieldName] !== undefined) {
      const isRequired = p.requiredFields[fieldName];
      return {
        visible: isRequired,
        required: isRequired,
      };
    }
    return { visible: false, required: false };
  };

  const createPhoneFieldConfig = (): PhoneFieldConfig => {
    if (p.fields?.user_phone) {
      return {
        visible: p.fields.user_phone.visible ?? false,
        required: p.fields.user_phone.required ?? false,
        requireVerification: p.fields.user_phone.requireVerification ?? false,
      };
    }
    if (p.requiredFields?.user_phone !== undefined) {
      const isRequired = p.requiredFields.user_phone;
      return {
        visible: isRequired,
        required: isRequired,
        requireVerification: false,
      };
    }
    return { visible: false, required: false, requireVerification: false };
  };

  const postAction = p.postRegistrationAction ?? "toast";
  const paymentConfig = p.paymentConfig ?? {
    enabled: false,
    paymentType: "one-time",
    description: "",
    amount: 1000,
    currency: "USD",
    plan_code: "",
  };
  const automatedEmail = p.automatedEmail ?? {
    enabled: false,
    sendDelay: "immediate",
    subject: "",
    content: "",
    attachments: [],
  };
  const esignature = p.esignature ?? {
    enabled: false,
    template_id: "",
    message: "",
    expiry_days: 30,
  };
  const booking = p.booking ?? {};

  return {
    requirePassword: p.requirePassword ?? false,
    formDescription: p.formDescription ?? "",
    fields: {
      user_last_name: createFieldConfig("user_last_name"),
      user_first_name: createFieldConfig("user_first_name"),
      user_phone: createPhoneFieldConfig(),
      user_country_code: createFieldConfig("user_country_code"),
      user_user_name: createFieldConfig("user_user_name"),
      user_birth_date: createFieldConfig("user_birth_date"),
    },
    customQuestions: p.customQuestions ?? [],
    customQuestionsPosition: p.customQuestionsPosition ?? "last",
    postRegistrationAction: postAction as "toast" | "redirect",
    redirectUrl: p.redirectUrl ?? "",
    paymentConfig: {
      enabled: paymentConfig.enabled ?? false,
      paymentType: paymentConfig.paymentType ?? "one-time",
      description: paymentConfig.description ?? "",
      amount: paymentConfig.amount ?? 1000,
      currency: paymentConfig.currency ?? "USD",
      plan_code: paymentConfig.plan_code ?? "",
    },
    automatedEmail: {
      enabled: automatedEmail.enabled ?? false,
      sendDelay: convertMinutesToSendDelay(automatedEmail.sendDelay ?? 0),
      subject: automatedEmail.subject ?? "",
      content: automatedEmail.content ?? "",
      attachments: automatedEmail.attachments ?? [],
    },
    esignature: {
      enabled: esignature.enabled ?? false,
      template_id: esignature.template_id ?? "",
      message: esignature.message ?? "",
      expiry_days: esignature.expiry_days ?? 30,
    },
    booking: {
      enabled: booking.enabled ?? BOOKING_DEFAULTS.enabled,
      type_id: booking.type_id ?? BOOKING_DEFAULTS.type_id,
    },
  };
};
